module.exports = __webpack_public_path__ + "img/shouhou.fbf64014.jpg";